export default __webpack_public_path__ + "static/media/logoWaterMarks.d02731cb.svg";